export const VOICE_API_URL = 'https://voice.sogni.ai';
export const DEFAULT_TTS_VOICE = 'aurochs';

function authorizationHeaders(apiKey) {
  return apiKey ? { 'X-API-Key': apiKey } : {};
}

async function throwVoiceError(response, message) {
  const detail = await response.json().catch(() => ({}));
  const error = new Error(detail.message || message);
  error.status = response.status;
  throw error;
}

// Fish S2 clone IDs are case sensitive. A failure must not change the voice.
export async function requestSpeech(text, {
  voice = DEFAULT_TTS_VOICE,
  apiKey,
  signal,
  fetchImpl = fetch
} = {}) {
  const response = await fetchImpl(
    `${VOICE_API_URL}/fish-tts/voices/clone/${encodeURIComponent(voice)}/generate`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authorizationHeaders(apiKey) },
      body: JSON.stringify({ text, format: 'wav' }),
      signal
    }
  );

  if (!response.ok) await throwVoiceError(response, 'Failed to generate speech');
  const audio = await response.blob();
  signal?.throwIfAborted();
  return audio;
}

export async function requestTranscription(audioBlob, { apiKey, fetchImpl = fetch } = {}) {
  const formData = new FormData();
  const extension = audioBlob.type.includes('webm') ? 'webm'
    : audioBlob.type.includes('mp4') ? 'mp4' : 'wav';
  formData.append('file', new File([audioBlob], `recording.${extension}`, { type: audioBlob.type }));

  const response = await fetchImpl(`${VOICE_API_URL}/transcribe`, {
    method: 'POST',
    headers: authorizationHeaders(apiKey),
    body: formData
  });

  if (!response.ok) await throwVoiceError(response, 'Failed to transcribe audio');
  const result = await response.json();
  if (!result.success) throw new Error(result.message || 'Transcription failed');
  return result.transcript;
}
